import { Comparable } from "@siteimprove/alfa-comparable";
import { Specificity } from "@siteimprove/alfa-selector";
import { Encapsulation } from "./encapsulation.js";
import { Layer } from "./layer.js";
import { Order } from "./order.js";
import { Origin } from "./origin.js";
/**
 * {@link https://drafts.csswg.org/css-cascade-5/#cascade-sort}
 *
 * @public
 */
export var Precedence;
(function (Precedence) {
    Precedence.empty = {
        origin: Origin.NormalUserAgent,
        encapsulation: -1 /* outermost normal */,
        isElementAttached: false,
        layer: Layer.empty(),
        specificity: Specificity.empty(),
        order: -Infinity,
    };
    function toJSON(precedence) {
        return {
            origin: precedence.origin,
            encapsulation: precedence.encapsulation,
            isElementAttached: precedence.isElementAttached,
            layer: precedence.layer.toJSON(),
            specificity: precedence.specificity.toJSON(),
            order: precedence.order,
        };
    }
    Precedence.toJSON = toJSON;
    function isImportant(precedence) {
        return Origin.isImportant(precedence.origin);
    }
    Precedence.isImportant = isImportant;
    function toTuple(precedence) {
        return [
            precedence.origin,
            precedence.encapsulation,
            precedence.isElementAttached,
            precedence.layer,
            precedence.specificity,
            precedence.order,
        ];
    }
    Precedence.toTuple = toTuple;
    function equals(a, b) {
        return (a.origin === b.origin &&
            a.encapsulation === b.encapsulation &&
            a.isElementAttached === b.isElementAttached &&
            a.layer.equals(b.layer) &&
            a.specificity.equals(b.specificity) &&
            a.order === b.order);
    }
    Precedence.equals = equals;
    Precedence.compare = (a, b) => Comparable.compareLexicographically(toTuple(a), toTuple(b), [
        Origin.compare,
        Encapsulation.compare,
        // In JS, true > false. This matches the behaviour of declarations from
        // a style attribute (isElementAttached = true) taking precedence over
        // declarations from a style rule.
        Comparable.compareBoolean,
        Layer.compare,
        Specificity.compare,
        Order.compare,
    ]);
})(Precedence || (Precedence = {}));
//# sourceMappingURL=precedence.js.map